import { Box, Button, Typography } from "@mui/material";

import * as sx from "@/pages/ActivityLibrary/components/ActivityCreatePage/ActivityCreatePage.styles";

export const ACTIVITY_CREATE_FORM_ID = "activity-create-form";
export const ActivityCreatePageHeader: React.FC<{
  onBackToActivities: () => void;
  onOpenLoadDraft: () => void;
  onOpenEditExisting: () => void;
  onSaveDraftClick: () => void;
  onSaveAndPublishClick: () => void;
}> = ({
  onBackToActivities,
  onOpenLoadDraft,
  onOpenEditExisting,
  onSaveDraftClick,
  onSaveAndPublishClick,
}) => (
  <Box sx={sx.activityCreatePageHeaderSx}>
    <Typography component="h1" sx={sx.activityCreatePageTitleSx}>
      Create Activity
    </Typography>
    <Box sx={sx.activityCreatePageActionsSx}>
      <Button
        variant="outlined"
        sx={sx.activityCreateSecondaryButtonSx}
        onClick={onBackToActivities}
      >
        Back to activities
      </Button>
      <Button
        variant="outlined"
        sx={sx.activityCreateSecondaryButtonSx}
        onClick={onOpenEditExisting}
      >
        Edit existing activity
      </Button>
      <Button variant="outlined" sx={sx.activityCreateSecondaryButtonSx} onClick={onOpenLoadDraft}>
        Load draft
      </Button>
      <Button
        variant="contained"
        sx={sx.activityCreatePrimaryButtonSx}
        type="submit"
        form={ACTIVITY_CREATE_FORM_ID}
        onClick={onSaveDraftClick}
      >
        Save draft
      </Button>
      <Button
        type="submit"
        variant="contained"
        sx={sx.activityCreatePrimaryButtonSx}
        form={ACTIVITY_CREATE_FORM_ID}
        onClick={onSaveAndPublishClick}
      >
        Save and publish
      </Button>
    </Box>
  </Box>
);
